{
  "labels": {
    "new_organization": "New Organization"
  },
  "input_labels": {
    "name": "Name",
    "description": "Description",
    "company_name": "Company Name",
    "email": "Email",
    "language": "Language",
    "line1": "Address Line 1",
    "line2": "Address Line 2",
    "line3": "Address Line 3",
    "city": "City",
    "state": "State",
    "country_code": "Country",
    "postal_code": "ZIP / Postal Code",
    "vat_number": "VAT Number"
  },
  "input_hints": {
    "name": "The display name of your organization",
    "description": "A short summary about what your organization does",
    "company_name": "The legal name registered with your local authority",
    "email": "Where we’ll send notifications and updates",
    "language": "The language used for emails",
    "vat_number": "Required for EU businesses for invoicing"
  },
  "input_groups": {
    "info": "Organization info",
    "contact": "Contact",
    "tax_info": "Tax info",
    "location": "Location"
  },
  "templates": {},
  "validation": {
    "name": {
      "empty": "Name is required",
      "min_length": "Min length of name is {{minLength}} characters",
      "max_length": "Max length of name is {{maxLength}} characters",
      "invalid": "Name should begin with a letter and end with a letter or digit. May include spaces, dots and dashes."
    },
    "companyName": {
      "empty": "Company Name is required"
    },
    "description": {
      "max_length": "Max length of description is 200 characters"
    },
    "email": {
      "invalid_email": "Enter a valid email"
    },
    "language": {
      "empty": "Language is required"
    },
    "address": {
      "line1": {
        "empty": "Address Line 1 is required"
      },
      "line2": {
        "empty": "Address Line 2 is required"
      },
      "line3": {
        "empty": "Address Line 3 is required"
      },
      "postalCode": {
        "empty": "ZIP / Postal Code"
      },
      "city": {
        "empty": "City is required"
      },
      "countryCode": {
        "empty": "Country is required",
        "not_positive": "$t(empty)"
      }
    }
  },
  "buttons": {
    "previous": "Previous",
    "next": "Next",
    "create": "Create"
  }
}
